
function calcMenuH(){
  let toolbar = document.querySelector("#shopify-section-toolbar");
  let toolBarHeight = 0;
  if(toolbar){
    toolBarHeight = toolbar.offsetHeight;
  }
  
  let menuh = document.querySelector("#HeaderWrapper");
  if(menuh != null){
    menuh = document.querySelector("#HeaderWrapper").offsetHeight;
  }
  else{
    menuh = 0;
  }
  return menuh + toolBarHeight;
}

function calcAnnouncement(){
  let announcementBar = document.querySelector(".toolbar");
  if(announcementBar != null){
    announcementBar = document.querySelector(".toolbar").offsetHeight;
  }
  else{
    announcementBar = 0;
  }
  return announcementBar;
}

let vh, menuh;
let send = false;

function viewportSizing(){
  // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
  vh = window.innerHeight * 0.01;
  // Then we set the value in the --vh custom property to the root of the document
  let size, sizeA;
  size = calcMenuH();
  sizeA = calcAnnouncement();
  document.documentElement.style.setProperty('--menuh', size+"px");
  document.documentElement.style.setProperty('--announcementBar', sizeA+"px");
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}


window.addEventListener("resize", function(){
  viewportSizing();
  vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--menuh', calcMenuH()+"px");
  document.documentElement.style.setProperty('--announcementBar', calcAnnouncement()+"px");
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});

document.addEventListener("DOMContentLoaded", e=>{
  viewportSizing();
});